// UTM capture + persistence across navigation
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const STORAGE_KEY = "vt_tracking_v1";

export function readUtmsFromUrl() {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  const out = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) out[k] = v;
  });
  return out;
}

export function getTrackingPayload() {
  if (typeof window === "undefined") return {};
  let saved = {};
  try {
    saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
  } catch (_) {
    saved = {};
  }
  const fromUrl = readUtmsFromUrl();
  const merged = { ...saved, ...fromUrl };

  const payload = {
    utm_source: merged.utm_source || null,
    utm_medium: merged.utm_medium || null,
    utm_campaign: merged.utm_campaign || null,
    utm_term: merged.utm_term || null,
    utm_content: merged.utm_content || null,
    referrer: merged.referrer || document.referrer || null,
    landing_page: merged.landing_page || (window.location.pathname + window.location.search) || null,
  };

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (_) {}

  return payload;
}

export function initTracking() {
  if (typeof window === "undefined") return;
  try {
    const existing = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
    if (!existing.landing_page) {
      const payload = getTrackingPayload();
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    }
  } catch (_) {}
}

export function getSessionId() {
  const KEY = "vt_sid";
  try {
    let sid = sessionStorage.getItem(KEY);
    if (!sid) {
      sid = (crypto.randomUUID && crypto.randomUUID()) || Math.random().toString(36).slice(2);
      sessionStorage.setItem(KEY, sid);
    }
    return sid;
  } catch (_) {
    return null;
  }
}
